import 'iconify-icon'
import 'htmx.org'

import './components/tv-shedule.js'
import './components/mobile-menu.js'
import './components/scroll-to-top.js'
import './components/post-content.js'


// Доп меню
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('raminfo-btn');
  const btnMobile = document.getElementById('raminfo-btn-mobile');
  const dropdown = document.querySelector('.raminfo-dropdown');
  const dropdownMobile = document.querySelector('.raminfo-dropdown-mobile');
  const arrow = document.getElementById('arrow-icon');
  const arrowMobile = document.getElementById('arrow-icon-mobile');

  btn?.addEventListener('click', () => {
    dropdown.classList.toggle('hidden');
    arrow?.setAttribute('icon', dropdown.classList.contains('hidden') ? 'solar:alt-arrow-down-bold' : 'solar:alt-arrow-up-bold');
  });

  btnMobile?.addEventListener('click', () => {
    dropdownMobile.classList.toggle('hidden');
    arrowMobile?.setAttribute('icon', dropdownMobile.classList.contains('hidden') ? 'solar:alt-arrow-down-bold' : 'solar:alt-arrow-up-bold');
  });

  document.addEventListener('click', (e) => {
    if (btn && !btn.contains(e.target) && !dropdown?.contains(e.target)) {
      dropdown?.classList.add('hidden');
      arrow?.setAttribute('icon', 'solar:alt-arrow-down-bold');
    }
    if (btnMobile && !btnMobile.contains(e.target) && !dropdownMobile?.contains(e.target)) {
      dropdownMobile?.classList.add('hidden');
      arrowMobile?.setAttribute('icon', 'solar:alt-arrow-down-bold');
    }
  });
});


// Скролл наверх страницы
document.addEventListener('DOMContentLoaded', function() {
  const scrollTopBtn = document.getElementById('scrollToTop');

  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});

// Сворачивание и разворачивание описания проектов (на главной
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-toggle-description').forEach(btn => {
    btn.addEventListener('click', function() {
      const desc = this.previousElementSibling;

      desc.classList.toggle('line-clamp-3');

      this.textContent = desc.classList.contains('line-clamp-3')
          ? 'Развернуть описание'
          : 'Свернуть описание';
    });
  });
});